import React, { useEffect } from 'react';
import {
    Box,
    Typography,
} from "@mui/material";
import Grid from "@mui/material/Grid2";
import { connect, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { sagaActions } from "../../helper/redux/actions/SagaActions";

import _DashWelcome from "./_DashWelcome";
import _DashAlerts from "./_DashAlerts";
import _DashSlider from "./_DashSlider";
import _DashCatItem from "../../components/_DashCatItem";
import _DashSummaryCards from "./reports/_DashSummaryCards";

import {
    CardGiftcardRounded,
    CategoryRounded,
    PeopleAltRounded,
    ReceiptLongRounded,
    SupportAgentRounded,
} from "@mui/icons-material";

const Dashboard = (props) => {
    const navigate = useNavigate();
    const corporate = useSelector(({ corporate }) => corporate.corporate);

    useEffect(() => {
        props.RequestCorporate(corporate);
    }, []);

    const SectionHeader = ({ title, subtitle, icon, action }) => (
        <Box
            sx={{
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'space-between',
                mb: 2,
                mt: 1.5,
                width: '100%',
            }}
        >
            <Box sx={{ display: 'flex', alignItems: 'center', gap: 1.5 }}>
                {icon && (
                    <Box
                        sx={{
                            width: 36,
                            height: 36,
                            borderRadius: 2.5,
                            bgcolor: 'rgba(45, 107, 226, 0.1)',
                            color: 'primary.main',
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center',
                            flexShrink: 0,
                        }}
                    >
                        {icon}
                    </Box>
                )}
                <Box sx={{ textAlign: 'right', direction: 'rtl' }}>
                    <Typography variant="h6" sx={{ fontWeight: 800, fontSize: '1.05rem', color: 'text.primary', textAlign: 'right', direction: 'rtl' }}>
                        {title}
                    </Typography>
                    {subtitle && (
                        <Typography variant="caption" sx={{ color: 'text.secondary', fontSize: '0.78rem', display: 'block', textAlign: 'right', direction: 'rtl' }}>
                            {subtitle}
                        </Typography>
                    )}
                </Box>
            </Box>
            {action}
        </Box>
    );

    return (
        <Box
            sx={{
                p: { xs: 2, sm: 2.5, md: 3.5 },
                maxWidth: 1600,
                mx: 'auto',
                width: '100%',
                display: 'flex',
                flexDirection: 'column',
                gap: 3,
            }}
        >
            <title>پیشخوان سازمانی | جیم‌پین</title>

            {/* ۱. بنر خوش‌آمدگویی و اقدامات سریع اصلی */}
            <_DashWelcome corporate={corporate} />

            {/* ۲. اعلان‌ها و پیام‌های فوری سازمان */}
            <_DashAlerts />

            {/* ۳. اسلایدر اخبار و معرفی طرح‌ها */}
            <Box sx={{ width: '100%' }}>
                <_DashSlider />
            </Box>

            {/* ۴. کارت‌های خلاصه مالی (مانده کیف‌پول سازمان و اعتبار فعال پرسنل) */}
            <Box sx={{ width: '100%' }}>
                <_DashSummaryCards corporateId={corporate?.Id} />
            </Box>

            {/* ۵. دسترسی سریع و ابزارهای کلیدی سازمان */}
            <Box sx={{ width: '100%', mb: 2 }}>
                <SectionHeader
                    title="دسترسی سریع به بخش‌های اصلی"
                    subtitle="ابزارهای کلیدی مدیریت و پایش"
                    icon={<CategoryRounded sx={{ fontSize: 20 }} />}
                />
                <Grid container spacing={2.5}>
                    <Grid size={{ xs: 12, sm: 6, md: 3 }}>
                        <_DashCatItem
                            title="تخصیص اعتبار به پرسنل"
                            description="اعتباردهی ورزشی به کل پرسنل یا گروه‌های منتخب"
                            icon={<CardGiftcardRounded sx={{ fontSize: 36, color: 'primary.main' }} />}
                            onClick={() => navigate("/allocations")}
                        />
                    </Grid>
                    <Grid size={{ xs: 12, sm: 6, md: 3 }}>
                        <_DashCatItem
                            title="لیست پرسنل"
                            description="مشاهده و مدیریت اطلاعات پرسنل سازمان"
                            icon={<PeopleAltRounded sx={{ fontSize: 36, color: 'primary.main' }} />}
                            onClick={() => navigate("/personnel")}
                        />
                    </Grid>
                    <Grid size={{ xs: 12, sm: 6, md: 3 }}>
                        <_DashCatItem
                            title="تراکنش‌های مصرف پرسنل"
                            description="ریز مصارف و خریدهای ورزشی پرسنل"
                            icon={<ReceiptLongRounded sx={{ fontSize: 36, color: 'primary.main' }} />}
                            onClick={() => navigate("/finance/transactions")}
                        />
                    </Grid>
                    <Grid size={{ xs: 12, sm: 6, md: 3 }}>
                        <_DashCatItem
                            title="پشتیبانی و تیکت‌ها"
                            description="ارسال پیام و پیگیری درخواست‌ها"
                            icon={<SupportAgentRounded sx={{ fontSize: 36, color: 'primary.main' }} />}
                            onClick={() => navigate("/support")}
                        />
                    </Grid>
                </Grid>
            </Box>
        </Box>
    );
};

export default connect(null, sagaActions)(Dashboard);
